import { rex_value, rex_number } from '@u/regex';
export function buildComputedForm(formObj) {
  return Object.keys(formObj).reduce((computedObj, key) => {
    computedObj[key] = {
      get() { return this.form[key].value },
      set(val) { this.form[key].value = val }
    }
    return computedObj;
  }, {})
}
export function intervalList(key, minDate, maxDate) {
  let result = [
    { key: key, type: 'min', value: timeStampFormat('start', minDate) },
    { key: key, type: 'max', value: timeStampFormat('end', maxDate) },
  ].filter((x) => rex_value(x.value));
  return result.length ? JSON.stringify(result) : undefined;
}
export function timeStampFormat(type, dateStr) {
  let result = undefined;

  if (isDateString(dateStr)) {
    //這次後端有做 >=, <= equal 判斷了
    if (type === 'start') {
      result = moment(moment(dateStr).format('YYYY-MM-DD 00:00:00')).valueOf();
    } else if (type === 'end') {
      result = moment(moment(dateStr).format('YYYY-MM-DD 23:59:59')).valueOf();
    }
  }
  return result;
}
export function isDateString(dateStr) {
  if (!dateStr) return false;
  let timeStamp = Number(new Date(dateStr)) || undefined;
  return !isNaN(timeStamp);
}
export function toLocaleString2(num) {
  if (rex_number(num)) {
    num = Number(num)
      .toLocaleString('en', {
        minimumFractionDigits: 3,
      })
      .replace(/\.?0+$/g, '');
  }
  return num;
}
export function formatFloat(number, decimalPlaces = 2, roundingMode = 'ceil') {
  let roundedNumber = number || 0;
  if (roundedNumber === 0) return 0;

  const factor = 10 ** decimalPlaces;
  const prevFactor = 10 ** (decimalPlaces + 1);

  if (rex_number(number)) {
    switch (roundingMode) {
      case 'floor': //無條件捨去
        roundedNumber = Math.floor(number * factor) / factor;
        break;
      case 'round': //四捨五入進位
        roundedNumber = Math.round(number * factor) / factor;
        break;
      case 'ceil': //無條件進位
      default:
        roundedNumber = Math.floor(roundedNumber * prevFactor);
        roundedNumber = Math.ceil(roundedNumber / 10) / factor;
        break;
    }
  }

  return roundedNumber;
}
export function stringFormat(value, rule) {
  let result = '';
  if ([undefined, null, ''].indexOf(value) === -1) {
    result = rule.replace('{0}', value);
  }
  return result;
}
export function moment2(format, date, novalue) {
  let result = novalue || '';
  if (!date) return result;
  if (!isDateString(date)) return date;
  if (rex_value(date)) {
    date = moment(date);
    if (format === 'timestamp') {
      result = date.valueOf();
    } else if (format === 'ISO0') {
      result = date.toISOString();
    } else if (format === 'me') {
      let end = date.endOf('month').date().toString().padStart('0', 2);
      result = date.format(`YYYY-MM-${end} 23:59:59`);
    } else if (format === 'local-datetime') {
      let period = date.hour() < 12 ? '上午' : '下午';
      result = `${date.format('YYYY/MM/DD')} ${period} ${date.format('hh:mm')}`;
    } else if (format === 'timeago') {
      let now = moment();
      let isToday = date.isSame(now, 'day');
      let isThisYear = date.isSame(now, 'year');

      if (isToday) {
        let period = date.hour() < 12 ? '上午' : '下午';
        result = `${period} ${date.format('hh:mm')}`;
      } else if (isThisYear) {
        result = date.format('M/D');
      } else {
        result = date.format('YYYY/M/D');
      }
    } else {
      result = date.format(
        {
          month: 'YYYY-MM',
          date: 'YYYY-MM-DD',
          datetime: 'YYYY-MM-DD HH:mm:ss',
          ys: 'YYYY-01-01 00:00:00', //year start
          ye: 'YYYY-12-31 23:59:59', //year end
          ms: 'YYYY-MM-01 00:00:00', //month start
          ds: 'YYYY-MM-DD 00:00:00', //day start
          de: 'YYYY-MM-DD 23:59:59', //day end
        }[format] || format
      );
    }
  }
  return result;
}
export function clockFormat(ms, config = {}) {
  const {
    showDefaultHour = true, //小時預設00
    type = 'default',
    lang = 'default',
  } = config;
  let seconds = Math.floor(ms / 1000);
  let result = [
    Math.floor(seconds / 3600) || (showDefaultHour ? 0 : undefined), //hours
    Math.floor((seconds % 3600) / 60), //minutes
    Math.floor((seconds % 3600) % 60), //seconds
  ];
  if (type === 'HH:mm') {
    result = result.slice(0, 2);
  }
  if (lang === 'default') {
    result = result
      .filter((x) => rex_value(x))
      .map((s) => String(s).padStart(2, '0'))
      .join(':');
  } else if (lang === 'cn') {
    result = result
      .map((x, i) => stringFormat(x, `{0}${['時', '分', '秒'][i]}`))
      .filter((x) => rex_value(x))
      .join('');
  }
  return result;
}
export const deepClone = (obj) => {
  // If `from` is an array, the `key` is index of each element
  if (obj === null || typeof obj !== 'object') {
    return obj; // 如果不是物件或為 null，直接返回
  }

  if (Array.isArray(obj)) {
    // 如果是陣列，建立一個新陣列並複製每個元素
    const newArray = [];
    for (let i = 0; i < obj.length; i++) {
      newArray[i] = deepClone(obj[i]);
    }
    return newArray;
  }

  // 如果是物件，建立一個新物件並複製每個屬性
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = deepClone(obj[key]);
    }
  }

  return newObj;
}